var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "width": "1224",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    title: _vm.title
  }, false), [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary pr-10",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "mb-12 mb-lg-20 pt-4"
  }, [_c('v-badge', {
    attrs: {
      "floating": "",
      "dot": ""
    }
  }, [_c('h4', {
    staticClass: "tit--sm line-height-1"
  }, [_vm._v("근로자 계약서")])])], 1), _c('vertical-form-table', _vm._b({
    staticClass: "flex-grow-1",
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false), [_c('template', {
    slot: "계약서 명칭"
  }, [_c('v-text-field', _vm._b({
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('template', {
    slot: "계약서 파일"
  }, [_c('v-file-input', _vm._b({
    on: {
      "change": _vm.initField
    },
    model: {
      value: _vm.form.file,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "file", $$v);
      },
      expression: "form.file"
    }
  }, 'v-file-input', _vm.attrs_input, false))], 1), _c('template', {
    slot: "계약서 필드"
  }, _vm._l(_vm.pages, function (page) {
    return _c('employment-form-pdf-page', _vm._b({
      key: page.pageNumber,
      attrs: {
        "propsFields": _vm.propsFields
      },
      on: {
        "pageMeta": _vm.pageMeta,
        "update": _vm.update
      }
    }, 'employment-form-pdf-page', {
      page: page,
      scale: _vm.scale,
      pageNumber: page.pageNumber
    }, false));
  }), 1)], 2)], 1), _c('div', {
    staticClass: "v-btn-group flex-wrap"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("취소하기")])]), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v("저장하기")])])], 1), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }